export const COOKIE_CONSENT_ACCEPTED_EVENT = 'cookie_consent_accepted_event';
export const COOKIE_CONSENT_REVOKED_EVENT = 'cookie_consent_revoked_event';
export const RETURNING_USER_WHO_ACCEPTED_COOKIE =
  'returning_user_who_accepted_cookie';
